import { gql } from '@apollo/client';

export const AddUniqueTeacherMutation = gql`
  mutation addUniqueTeacher(
    $application: ApplicationInputType!
    $employmentTypes: EmploymentInputType!
    $teacher: NewTeacherInput!
  ) {
    createUniqueTeacher(
      application: $application
      employmentTypes: $employmentTypes
      teacher: $teacher
    ) {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;

// Standalone teacher creation (spec 0007 rev.): registers a «свободный»
// teacher with no application / employment type — just the base credentials
// and an optional site-display flag. Operation name ≠ backend field
// (`createTeacher`) to avoid a codegen result-type collapse.
export const AddTeacherStandaloneMutation = gql`
  mutation AddTeacherStandalone($teacher: NewTeacherInput!) {
    createTeacher(teacher: $teacher) {
      success
      customErrors {
        field
        message
        code
      }
      teacher {
        id
        fullName
      }
    }
  }
`;

export const AddTeacherRoleMutation = gql`
  mutation addNewTeacherRole(
    $application: ApplicationInputType!
    $employmentTypes: EmploymentInputType!
    $siteDisplay: Boolean
    $userId: ID!
  ) {
    addTeacherRole(
      application: $application
      employmentTypes: $employmentTypes
      siteDisplay: $siteDisplay
      userId: $userId
    ) {
      success
      customErrors {
        field
        message
        code
      }
    }
  }
`;

export const AddTeacherExistMutation = gql`
  mutation AddTeacherExist(
    $application: ApplicationInputType!
    $employmentTypes: ExistEmploymentInputType!
    $teacherId: ID!
  ) {
    addTeacherExist(
      application: $application
      employmentTypes: $employmentTypes
      teacherId: $teacherId
    ) {
      success
      customErrors {
        field
        message
        code
      }
      application {
        id
      }
    }
  }
`;

export const UpdateTeacherMutation = gql`
  mutation editTeacherWithType(
    $employmentInput: ExistEmploymentInputType!
    $teacherId: ID
    $teacherInput: TeacherWithTypeInput!
  ) {
    updateTeacherWithType(
      teacherId: $teacherId
      employmentInput: $employmentInput
      teacherInput: $teacherInput
    ) {
      success
      errors
      customErrors {
        field
        message
        code
      }
    }
  }
`;

// Teacher control-panel profile fields (spec 0007): rating (1-5, 0 clears),
// internal note, interview recording URL, and the courses the teacher can
// teach. Operation name ≠ backend field (`setTeacherProfile`) to avoid a
// codegen result-type collision.
export const SetTeacherProfileMutation = gql`
  mutation SaveTeacherProfile(
    $teacherId: ID!
    $rating: Int
    $internalNote: String
    $interviewRecording: String
    $coursesCanTeachIds: [ID!]
  ) {
    setTeacherProfile(
      teacherId: $teacherId
      rating: $rating
      internalNote: $internalNote
      interviewRecording: $interviewRecording
      coursesCanTeachIds: $coursesCanTeachIds
    ) {
      success
      customErrors {
        field
        message
        code
      }
      teacher {
        id
        rating
        internalNote
        interviewRecording
        coursesCanTeach {
          id
          name
        }
      }
    }
  }
`;
